import { AxiosInstance } from 'axios';
import { Tag } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'tag';

export class TagApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getSponsoredTags(filter?: string): Promise<Array<Tag>> {
    await simulate();
    const params = new URLSearchParams();

    if (filter) {
      params.append('filter', filter);
    }
  
    const queryString = params.toString();
    const url = queryString ? `/sponsored?${queryString}` : '/sponsored';
    const response = await this.apiInstance.get(url);

    return response.data;
  }
}
